
export class limitsofliabilityforinsurancelosses { 
    ransom: string;
    ransomDeductible: string;
    personalBelongings:string;
    transit: string;
    legalLiability: string;
    additionalExpenses: string;
    crisisResponseFees: string;
    recallExpenses: string;
    aaForAllInsuredLosses: string;
    accidentalDAndDPerInsuredPerson: string;
    accidentalDAndDPerEvent:string;
         
}
export class additionalcoveredeventexpenses { 
    threatResponseExpense: string;
    threatAnnualAggregate: string;
    threadIndemnityPeriod: string;
    threatWaitingPeriod: string;
    disappearanceInvestigationExpense: string;
    disappearanceAnnualAggregate: string;
    disappearanceIndemnityPeriod: string;
    disappearanceWaitingPeriod: string;
}
export class quoteInfo {   
    termLength: string;    
    effectiveDate: string;    
    expirationDate: string;    
    additionalEntities: string;    
    limitsOfLiabilityForInsuranceLosses: limitsofliabilityforinsurancelosses;     
    additionalCoveredEventExpenses: additionalcoveredeventexpenses;
}
export class rating{
    basePremium: basePremium;
    modifiedBasePremium: modifiedBasePremium;
    limitModification: limitModification;
    coverageModifiers: coverageModifiers;
    riskQualityModifiers: riskQualityModifiers;
    workplaceViolence: workplaceViolence;
    medicalEvacuation: medicalEvacuation;
    customPremium: number;;
    // oneYearPremium: number;
    // twoYearPremium: number;
    // threeYearPremium: number;
    limitPremiums:limitPremiums[]
}
export class basePremium { 
    keyEmployees: string;
    allOtherEmployees: string;
    assetSize: string;
    totalExposurePoints: string;
    companyVisibility: string;
    individualVisibility: string;
    basePremium: string;
}
export class modifiedBasePremium {
    grossRevenue: string;
    deductible: string;
    specialIndustry: string;
    claims: string;
    modifiedBasePremium: string;
 }
export class limitModification { 
    limitOfInsurance:string;
    disappearanceAndInvestigation: string;
    threatResponse: string;
    recallResponse: string;
    personalBelongings:string; 
    travelSecurityEvacOption:string;
    travelSecurityEvacLimit: string;
    expatriateSecurityEvacOption: string;
    expatriateSecurityEvacLimit:string; 
    modifiedLimitPremium: string;
}
export class coverageModifiers {
    adAndDLimit:string;
    childAbductionLimit: string;
    wwInclusiveDeductible:string;
    territorialInclusiveDeductible: string;
    wwInclusiveAggregate: string;
    territorialExclusions:string;
    territorialSublimit: string;
    amendedTravel: string;
    amendedInsuredPersons:string;
    lossOfEarnings:string;
    amendedThreat:string;
    amendedDisappearance: string;
    exclusionaryEndorsement: string;
    excEndorsementMod: string;
    cyberSubLimitEndorsement: string;
    cyberSubLimitEndorsementMod: string;
    cyberEndorsement: string;
    cyberEndorsementMod: string;
    productsValue: string;
    amendedLossEarn: string;
    amendedLossEarnCyberSubLimit: string;
 }
export class riskQualityModifiers {
    riskAdvisory: string;
    riskTravel: string;
    riskConsultant:string;
    riskCMRecom: string;
    riskCMPlan: string;
    riskProduct: string;
    riskProductAnimal: string;
    riskUnityPortal:string;
    riskUnityGuidelines:string; 
    riskUnityMeeting: string;
    riskUnityProposal:string;
    riskUnityTelephone: string;
    riskCountryReports: string;
 }
export class workplaceViolence { 
    wpvCoverage: string;
    numberOfEmployees:string;
    limitOfLiability: string;
    businessOperations: string;
    numberOfLocations:string;
    workplaceReduction: string;
    workplacePractices: string;
    securityControls: string;
    priorClaims: string;
    financialStability: string;
    yearsInBusiness: string;
    mandAActivity: string;
    riskComplexity: string;
    wpvPremium: string;
}
export class medicalEvacuation {
    costs:string;
    medEvacCoverage: string;
    travelDays: string;
    medEvacPremium: string;
 }

export class productType{
    quoteNumber?:string;
    lob:string;
    policyType:string;
    carrier: string;
    currency: string;
    territory: string;
    aS400QuoteNumber: string;
}
export class insuredAddress
{
    street?: string;
    suiteOrUnit?: string;
    city: string;
    state: string
    zipCode: string;
    country: string;
}
export class insured{
    insuredName:string;     
    address: insuredAddress;      
}

export class underwritingInformation
{
    underwriter: string;
    underwriterAssistant?: string;
}
export class brokerInformation
{
    brokerName:string;
    brokerCommissionPercentage:number
    brokerNumber:string;
    brokerAddress:BrokerAddress;
    contactName:string;
}
export class BrokerAddress
{
    Street?:string;
    SuiteOrUnit?:string;
    City:string;
    State:string;
    ZipCode:string;
    Country:string;
}
export class UpdateQuoteRequest
{
    QuoteId? : string;
    QuoteNumber?: string;
    PolicyFrom: string;
    PolicyTo: string;
    TimeZoneOffset: string;
    ProductType: ProductTypeUpdate;
    Insured:insured;
    UnderwritingInformation: underwritingInformation;    
}
export class ProductTypeUpdate{    
    //Lob:string;
    PolicyType:string;
    Carrier: string;
    Currency: string;
    //Territory: string;
    AS400QuoteNumber: string;
    NewRenewal: string;
    BrokerCommissionPercentage: string;
}

export class QuoteResponseData{
    QuoteDetails:quoteDetail;
}
export class wwExposure{
    countries:string;
}
export class limitPremiums{
    limitOfInsurance: number;
    finalPremiums: finalPremiums;
    premiums: premiums;
}
export class finalPremiums{
    oneYearPremium: string;
    twoYearPremium: string;
    threeYearPremium: string;
    threeYearInsPremium: string;
}
export class premiums{
    base: string;
    medEvac: string
    modBase: string
    modLimit: string
    wpv: string
}
export class quoteDetail{   
    quoteId?: string;    
    quoteNumber?: string;    
    productType?: productType;    
    insured?: insured;    
    underwritingInformation?: underwritingInformation;           
    rating: rating;    
    quoteInfo: quoteInfo;
    wwExposure: wwExposure;    
}